import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import LoginPage from "./Components/LoginPage";
import Home from "./Components/Home";
import OrderConfirmation from "./Components/OrderConfirmation";
import OrderCompleted from "./Components/OrderCompleted";
import Mode from "./Components/Mode";
import SaleOrder from "./Components/SaleOrder";
import SignupPage from "./Components/SignupPage";
import Temp from "./Components/Temp";
import Profile from "./Components/Profile";
import Footer from "./Components/Footer";
import RefundPolicy from "./Components/OfficeContact";
import TermsAndConditions from "./Components/TermsConditions";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Dzyris from "./Components/Dzyris";

// GuestHandler component
const GuestHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const isGuest = queryParams.get("guest") === "true";
    const restaurantId = queryParams.get("restaurantId");

    if (isGuest && restaurantId) {
      localStorage.setItem("role", "guest");
      localStorage.setItem("restaurantId", restaurantId);
      navigate("/home", { replace: true });
    }
  }, [location.search, navigate]);

  return children;
};

const App = () => {
  return (
    
    <GuestHandler>
      <Routes>
        <Route path="/" element={<Dzyris />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/temp" element={<Temp />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/order-completed" element={<OrderCompleted />} />
        <Route path="/mode" element={<Mode />} />
        <Route path="/SaleOrder" element={<SaleOrder />} />
        <Route path="/vendor/:id" element={<Profile />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
    </GuestHandler>
    
  );
};

export default App;
